export default function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/node_modules/rc-util/es/Dom/canUseDom.js
// module id = 561
// module chunks = 0